import React from "react";

export default function UniComply() {
  return (
    <svg
      width="175"
      height="168"
      viewBox="0 0 175 168"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M135.152 16.3199C136.084 14.9042 135.695 12.9958 134.246 12.1165C123.727 5.73317 111.915 1.74646 99.6529 0.457546C86.3723 -0.938427 72.9506 0.870868 60.5137 5.73365C48.0769 10.5964 36.9876 18.3709 28.1761 28.4048C20.0403 37.6692 14.0655 48.6104 10.6661 60.4358C10.1978 62.0647 11.2062 63.7311 12.8512 64.1393L14.1518 64.4619C15.7968 64.87 17.4551 63.8651 17.9293 62.2378C21.037 51.5724 26.4482 41.7049 33.7949 33.339C41.8173 24.2036 51.9136 17.1254 63.2368 12.698C74.56 8.27068 86.7798 6.6234 98.8712 7.89437C109.944 9.05828 120.613 12.6384 130.131 18.3672C131.583 19.2412 133.483 18.8548 134.415 17.4391L135.152 16.3199Z"
        fill="url(#paint0_linear_6021_8713)"
      />
      <path
        d="M10.5226 81.0364C8.82852 80.9843 7.40705 82.3159 7.41726 84.0107C7.49635 97.1377 10.6697 110.077 16.6977 121.771C23.1951 134.375 32.795 145.116 44.5926 152.984C56.3902 160.851 69.9969 165.584 84.1301 166.738C97.2425 167.808 110.407 165.764 122.556 160.792C124.125 160.15 124.808 158.325 124.108 156.782L123.556 155.561C122.856 154.017 121.04 153.338 119.469 153.975C108.479 158.427 96.5851 160.252 84.7384 159.285C71.8708 158.235 59.4825 153.925 48.7414 146.762C38.0002 139.6 29.2599 129.82 23.3444 118.344C17.8982 107.779 15.0114 96.0977 14.8971 84.2405C14.8808 82.5457 13.5561 81.1296 11.862 81.0775L10.5226 81.0364Z"
        fill="url(#paint1_linear_6021_8713)"
      />
      <circle
        cx="12.5314"
        cy="82.0932"
        r="12.5314"
        fill="url(#paint2_linear_6021_8713)"
      />
      <path
        d="M133.549 151.723C134.447 153.16 136.344 153.602 137.748 152.652C147.188 146.259 155.229 137.994 161.364 128.359C168.049 117.859 172.302 105.999 173.813 93.6438C175.324 81.289 174.054 68.7527 170.096 56.9519C166.463 46.1221 160.651 36.1631 153.03 27.6838C151.897 26.4232 149.949 26.3949 148.731 27.5735L147.768 28.5052C146.55 29.6838 146.523 31.6226 147.652 32.8873C154.501 40.5627 159.728 49.5568 163.006 59.3299C166.61 70.0739 167.766 81.4876 166.391 92.7361C165.015 103.985 161.143 114.783 155.056 124.342C149.52 133.038 142.279 140.507 133.782 146.306C132.382 147.261 131.941 149.149 132.839 150.587L133.549 151.723Z"
        fill="url(#paint3_linear_6021_8713)"
      />
      <circle
        cx="131.451"
        cy="16.1122"
        r="12.5314"
        fill="url(#paint4_linear_6021_8713)"
      />
      <circle
        cx="139.38"
        cy="147.308"
        r="12.5314"
        fill="url(#paint5_linear_6021_8713)"
      />
      <path
        d="M94.4049 95.2562V64.1671C94.8869 60.0204 105.621 60.5107 105.988 64.167V71.0051C105.988 75.2633 105.306 75.3337 108.379 75.3337H115.249C117.65 75.6498 117.368 77.3933 117.368 79.3004V91.5904C117.368 101.174 109.275 116.041 82.5673 111.705C93.08 108.028 94.4049 99.6926 94.4049 95.2562Z"
        fill="url(#paint6_linear_6021_8713)"
      />
      <path
        d="M48.5914 96.4507C54.0847 128.611 96.433 136.801 114.012 107.437C90.3979 123.076 71.3129 117.463 71.3129 96.4507L71.085 58.8386C70.9298 58.0956 71.4127 56.6816 69.6021 56.2637H59.1254C57.1353 56.5092 57.367 57.5783 57.367 58.8386V64.8862C57.5099 66.8054 57.367 67.039 55.0591 66.9261H50.7425C48.5914 66.9261 48.5914 66.9261 48.5914 68.6846V96.4507Z"
        fill="url(#paint7_linear_6021_8713)"
      />
      <path
        d="M149.777 26.5643C148.14 26.4865 146.566 27.2205 145.506 28.4703C139.884 35.0997 135.273 40.4254 131.196 43.2204L132.602 45.5224L134.904 45.9054C136.695 42.0687 147.818 30.1084 151.911 26.9113C151.378 26.6906 150.668 26.6067 149.777 26.5643Z"
        fill="#0C7E9B"
      />
      <path
        d="M128.521 41.822C127.674 41.822 126.987 42.509 126.987 43.3563L126.987 47.6175C124.343 51.8964 121.322 54.728 117.346 56.6053L123.357 61.9758C124.858 57.4743 127.921 53.8081 131.701 50.6918L134.322 50.692C135.169 50.692 135.857 50.005 135.857 49.1575L135.857 43.3566C135.857 42.5092 135.17 41.8225 134.322 41.8225L128.521 41.822Z"
        fill="url(#paint8_linear_6021_8713)"
      />
      <path
        d="M99.3159 44.3117L107.756 44.3119C108.603 44.3119 109.29 44.9987 109.29 45.8461L109.289 50.7067C111.382 53.8263 114.157 55.4535 118.242 56.7332L113.894 62.487C111.179 58.6416 109.364 57.098 105.442 55.8192L99.3158 55.8199C98.4685 55.8198 97.7815 55.1331 97.7815 54.2858L97.7817 45.8461C97.7818 44.9988 98.4686 44.3119 99.3159 44.3117Z"
        fill="url(#paint9_linear_6021_8713)"
      />
      <rect
        x="113.222"
        y="55.6831"
        width="10.6884"
        height="10.6884"
        rx="1.53446"
        fill="#24C1D3"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6021_8713"
          x1="39.6159"
          y1="24.6792"
          x2="171.583"
          y2="169.244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6021_8713"
          x1="39.6159"
          y1="24.6792"
          x2="171.583"
          y2="169.244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6021_8713"
          x1="4.83207"
          y1="73.2652"
          x2="24.6354"
          y2="94.959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6021_8713"
          x1="39.6159"
          y1="24.6792"
          x2="171.583"
          y2="169.244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6021_8713"
          x1="123.752"
          y1="7.28425"
          x2="143.555"
          y2="28.9781"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6021_8713"
          x1="131.68"
          y1="138.48"
          x2="151.484"
          y2="160.174"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6021_8713"
          x1="83.0202"
          y1="69.463"
          x2="114.627"
          y2="74.0182"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.110577" stopColor="#0C7E9B" />
          <stop offset="0.370192" stopColor="#1FC1D3" />
          <stop offset="0.596154" stopColor="#95D3DD" />
          <stop offset="0.776982" stopColor="#1FC1D3" />
          <stop offset="1" stopColor="#3DC5D6" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_6021_8713"
          x1="49.4427"
          y1="67.3884"
          x2="107.738"
          y2="79.062"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.110577" stopColor="#0C7E9B" />
          <stop offset="0.370192" stopColor="#1FC1D3" />
          <stop offset="0.596154" stopColor="#95D3DD" />
          <stop offset="0.776982" stopColor="#1FC1D3" />
          <stop offset="1" stopColor="#0A829D" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_6021_8713"
          x1="143.855"
          y1="51.66"
          x2="120.088"
          y2="67.3464"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.110577" stopColor="#0C7E9B" />
          <stop offset="0.364199" stopColor="#1FC1D3" />
          <stop offset="0.596154" stopColor="#95D3DD" />
          <stop offset="0.776982" stopColor="#1FC1D3" />
          <stop offset="1" stopColor="#19AFC4" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_6021_8713"
          x1="97.1438"
          y1="47.836"
          x2="121.93"
          y2="57.2691"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0C7E9B" />
          <stop offset="0.293269" stopColor="#1FC1D3" />
          <stop offset="0.480769" stopColor="#95D3DD" />
          <stop offset="0.776982" stopColor="#1FC1D3" />
          <stop offset="1" stopColor="#0A829D" />
        </linearGradient>
      </defs>
    </svg>
  );
}
